module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Front"
    }
  }, [_c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_c('i', [_vm._v("Tiger")]), _vm._v(", "), _c('i', [_vm._v("Lion")]), _vm._v(" and, in the distance, "), _c('i', [_vm._v("Princess Royal")]), _vm._v(" in typical North Sea conditions.")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('p', {
    staticClass: "fig-img"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("A perfect broadside view of "), _c('i', [_vm._v("Invincible")]), _vm._v(" in 1910. Visually, dreadnought-era ships – both battleships and battlecruisers – introduced an entirely new element of asymmetry, which must have made the ships look at once novel and dramatic. Pre-dreadnought battleships and cruisers were marked by a balanced profile, with equally spaced funnels, a gun mounting fore and aft, and rows of ventilators all the same height; often the forward half of the ship was virtually a mirror image of the after part. Wing turrets made this impossible, and even when ships went over to an all-centreline main armament, they never regained the push-me-pull-you look of the previous generation.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9bdd564","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Front.vue
// module id = 57
// module chunks = 0